<template>
    <section class="esesja-modal">
        <section class="esesja-modal__wraper">
            <section class="esesja-modal__wraper__header">
                <h3 class="esesja-modal__wraper__header__title">{{$t('com.file.add-voting-modal.edit-voting')}}</h3>
                <button class="esesja-modal__wraper__header__exit-btn"
                        @click=" (e)=>{e.preventDefault(); this.$emit('closeEditVotingNameModal');}">
                    <img src="../../../../../assets/icons/components/exit-btn.svg" />
                </button>
            </section>
            <perfect-scrollbar class="esesja-modal__wraper__body">
                <label class="esesja-modal__wraper__body__label">{{$t('com.file.edit-voting-name-modal.voting-name')}}</label>
                <section class="esesja-modal__row">
                    <textarea
                           rows="5"
                           :placeholder="$t('com.file.edit-voting-name-modal.voting-name-placeholder')"
                           class="esesja-modal__wraper__body__input"
                           v-model="name"></textarea>
                </section>

                <section style="margin-bottom: 20px;" class="d-flex flex-column gap-2">
                    <p>{{$t('com.file.edit-voting-name-modal.held')}}: <b>{{metadata.adminName}}</b></p>
                    <p>{{$t('com.file.edit-voting-name-modal.voting-start-time')}}: <b>{{formatDateToDisplay(metadata.startDate, 'dayMonthTextYearTime')}}</b></p>
                    <p>{{$t('com.file.edit-voting-name-modal.voting-save-time')}}: <b>{{formatDateToDisplay(metadata.endDate, 'dayMonthTextYearTime')}}</b></p>
                    <p>{{$t('com.file.add-voting-modal.voting-transparency')}}: <b>{{metadata.isPublic ? $t('com.file.add-voting-modal.public-voting') : $t('com.file.add-voting-modal.secret-voting')}}</b></p>
                    <p>{{$t('com.file.add-voting-modal.voting-mode')}}: <b>{{metadata.mode > 1 ? metadata.modeName : $t('com.file.personal-info.lack')}}</b></p>
                    <p>{{$t('com.file.edit-voting-name-modal.voting-excluted')}}: <b>{{metadata.excluted != null && metadata.excluted.length > 0 ? exclutedToDisplay(metadata.excluted) : $t('com.file.personal-info.lack')}}</b></p>
                    <p>{{$t('com.file.add-voting-modal.voting-groups')}}: <b>{{metadata.groups != null && metadata.groups.length > 0 ? exclutedToDisplay(metadata.groups) : $t('com.file.personal-info.lack')}}</b></p>
                </section>

                <section class="esesja-modal__wraper__body__bottom">
                    <button class="esesja-modal__wraper__body__bottom-button"
                            @click="this.$emit('closeEditVotingNameModal')">
                        {{$t('com.global.cancel')}}
                    </button>
                    <button class="
                        esesja-modal__wraper__body__bottom-button
                        esesja-modal__wraper__body__bottom-button--red
                    "
                            @click="handleSaveClick" :disabled="name.length == 0">
                        {{$t('com.global.save')}}
                    </button>
                </section>
            </perfect-scrollbar>

        </section>
        <LoaderInside v-if="isLoading" />
    </section>
</template>

<script charset="utf-8">
import LoaderInside from "../../../../BasicControls/LoaderInside.vue";
import VotingService from "../../../../../services/voting.service";
import { encryptStorage } from '../../../../../services/encrypt.service';
import { formatDateToDisplay } from "../../../../../helpers/i18n.utils";

export default {
    name: "EditVotingNameModal",
    data() {
        return {
            name: this.tempVotingNameToEdit,
            isLoading: false,
            votingModule: encryptStorage.getItem('modules').g,
            metadata: {
                adminName: '',
                startDate: '',
                endDate: '',
                isPublic: 1,
                mode: 1,
                modeName: this.$t('com.file.edit-voting-name-modal.no-voting-mode'),
                excluted: [
                    {
                        id: 0,
                        name: ''
                    }
                ],
                groups: null
            },
        };
    },
    props: {
        tempVotingNameToEdit: String,
        tempVotingId: Number,
        pointID: Number,
        session: Number
    },
    components: {
        LoaderInside,
    },
    async mounted() {
        await this.getMetadata();
    },
    methods: {
        async getMetadata() {
            try {
                if (this.votingModule == 1 || this.tempVotingId > 0) {

                    let result = await VotingService.getVotingMetadata(this.tempVotingId, this.pointID, this.session)

                    if (result.status == 200) {
                        this.metadata = result.data;
                    }
                }
            }
            catch (e) {
                if (e.response.status == 401)
                    this.$router.push({ name: 'Login' })
            }
        },
        formatDateToDisplay,
        exclutedToDisplay(excluted) {
            var str = ''

            for (var i = 0; i < excluted.length; i++) {
                str += excluted[i].name + ", ";
            }

            return str.replace(/,\s*$/, "");
        },
        handleSaveClick() {
            this.isLoading = true;
            const data = {
                id: this.tempVotingId,
                name: this.name,
                sid: this.session
            };

            VotingService.editVotingName(this.pointID, data).then(() => {
                this.name = "";
                this.$emit("reload");
                this.$emit("closeEditVotingNameModal");
                this.isLoading = false;
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    @use "../../../../../assets/scss/esesja-modal.scss";

    .esesja-modal__wraper__body__input{
        width: 600px;
    }
</style>

